module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-user"
  }, [_c('div', {
    staticClass: "user-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatarPath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.userInfo.realName))]), _vm._v(" "), _c('span', {
    staticClass: "user-account"
  }, [_vm._v("账号：" + _vm._s(_vm.userInfo.account))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "user-tip"
  }, [_c('span', [_vm._v("手机号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userInfo.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "user-tip"
  }, [_c('span', [_vm._v("角色")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userInfo.roleName))])])]), _vm._v(" "), _c('div', {
    staticClass: "remove-account",
    on: {
      "click": _vm.btn
    }
  }, [_vm._v("解除绑定")]), _vm._v(" "), _c('Nav', {
    attrs: {
      "navIndex": 2
    }
  }), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "show-cancel-button": ""
    },
    on: {
      "confirm": _vm.removeInfo
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
    staticClass: "make"
  }, [_vm._v("解除后将不会再收到新美云待办提醒，也不能再处理新美云待办事项")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f2f7f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/appUserInfo.vue
// module id = 1659
// module chunks = 471